// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"vy_a bgu_b bgu_ux"};